<template>
  <v-card
    outlined
    class="px-6"
  >
    <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">{{ label }}</label>
    <v-menu
      v-model="datePickerModaL"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateInputListener"
          prepend-inner-icon="mdi-calendar"
          :label="label"
          outlined
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        scrollable
        v-model="dateInputListener"
        @input="datePickerModaL = false"
      ></v-date-picker>
    </v-menu>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      datePickerModaL: false
    }
  },
  props: {
    dateInput: {
      type: [String, Object],
      default: null
    },
    label: {
      type: String,
      default: 'Date'
    }
  },

  computed: {
    dateInputListener: {
      get () {
        return this.dateInput
      },
      set (val) {
        this.$emit('update:dateInput', val)
      }
    }
  }
}
</script>
